import React from 'react';
import { Outlet } from 'react-router-dom';

import Authenticated from './Authenticated';
import Restricted from './Restricted';

const Route = () => {
  return <Outlet />;
};

Route.Authenticated = Authenticated;
Route.Restricted = Restricted;

export default Route;
